import { api } from './authService';
import { xProjectIdConfig } from '../utils/projectScope';

function getTenantCode(): string {
  return localStorage.getItem('currentTenant') || 'default';
}

export interface PermissionSwitchConfigRecord {
  id?: number;
  tenant_code: string;
  project_id?: string | number | null;
  type: string;
  data_ownership?: boolean | null;
  is_synchronized?: boolean | null;
  model_branch?: boolean | null;
  enabled?: boolean | null;
  synced_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface PermissionSwitchesResponse {
  success: boolean;
  message?: string;
  data: {
    source?: 'local' | 'remote';
    record?: PermissionSwitchConfigRecord[] | null;
    switches?: Record<string, any> | null;
    remote?: any;
  };
}

export interface PermissionSwitchUpdateRequest {
  activeSystem: string;
  switches: Record<string, any>;
}

export async function fetchPermissionSwitches(
  options?: { source?: 'local' | 'remote'; projectId?: string | number | null }
) {
  const tenant = getTenantCode();
  const response = await api.get<PermissionSwitchesResponse>(
    `/${tenant}/chatbi/permissions/switches`,
    {
      params: options?.source ? { source: options.source } : undefined,
      ...xProjectIdConfig(options?.projectId),
    }
  );
  return response.data;
}

export async function syncPermissionSwitches(projectId?: string | number | null) {
  const tenant = getTenantCode();
  const response = await api.post<PermissionSwitchesResponse>(
    `/${tenant}/chatbi/permissions/sync`,
    undefined,
    xProjectIdConfig(projectId)
  );
  return response.data;
}

export async function updatePermissionSwitches(payload: PermissionSwitchUpdateRequest, projectId?: string | number | null) {
  const tenant = getTenantCode();
  const response = await api.post<PermissionSwitchesResponse>(
    `/${tenant}/chatbi/permissions/switches`,
    payload,
    xProjectIdConfig(projectId)
  );
  return response.data;
}

export async function fetchPermissionSwitchHistory(limit: number = 20, projectId?: string | number | null) {
  const tenant = getTenantCode();
  const response = await api.get<{
    success: boolean;
    data: Array<{ record: PermissionSwitchConfigRecord; switches: Record<string, any> | null }>;
  }>(`/${tenant}/chatbi/permissions/history`, {
    params: { limit },
    ...xProjectIdConfig(projectId),
  });
  return response.data;
}

export async function publishPermissionSwitches(projectId?: string | number | null) {
  const tenant = getTenantCode();
  const response = await api.post<PermissionSwitchesResponse>(
    `/${tenant}/chatbi/permissions/publish`,
    undefined,
    xProjectIdConfig(projectId)
  );
  return response.data;
}

